<div class="page-head-section">
  <p>Archers nominated for GC</p>
</div>

<div class="archers-content">
  <div class="ui-g archer-head-row">
    <div class="ui-g-2">
      <p class="heading-archer" style="text-align: left"></p>
    </div>
    <div class="ui-g-3">
      <p class="heading-archer">Name</p>
    </div>
    <div class="ui-g-3">
      <p class="heading-archer">Phone</p>
    </div>
    <div class="ui-g-4">
      <p class="heading-archer">Address</p>
    </div>
  </div>

  <div *ngFor="let data of ArcherData" class="ui-g archer-content-row">
    <div class="ui-g-2">
      <div class="player-name" style="text-align: left">
        <div *ngIf="data?.link !== ''">
          <img class="profile-img" [src]="global.basePathImage + data?.link" alt="" />
        </div>

        <img
          *ngIf="data?.link === ''"
          class="profile-img"
          src="assets/icons/noUser.svg"
          alt=""
        />
      </div>
    </div>

    <div class="ui-g-3">
      <p class="content-archer">{{ data?.name }}</p>
    </div>
    <div class="ui-g-3">
      <p class="content-archer">{{ data?.phone }}</p>
    </div>

    <div class="ui-g-4">
      <div class="gender">
        <p class="content-archer">{{ data?.address }}</p>
      </div>
    </div>
  </div>
</div>
